exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove[data-v-6862160f]{cursor:pointer}.items[data-v-6862160f]{overflow-y:auto;height:calc(100% - 154.85px);scrollbar-color:#373737 transparent;scrollbar-width:thin}.items[data-v-6862160f]::-webkit-scrollbar{background:#f0f0f0;width:5px}.items[data-v-6862160f]::-webkit-scrollbar-thumb{border-radius:1rem;background:#373737}", ""]);

// exports
